import React, { useEffect, useState } from "react";
import styles from "./ExportClientsToExcelModal.module.css";
import { Modal, Row } from "react-bootstrap";
import Select from 'react-select';
import TemplateDownload from "../../../../../Reusables/components/TemplateDownload/TemplateDownload";
import { TemplateOption } from "../../../../../pages/engagement_letter/CreateEngagementLetterWizard/components/EngagementLetterTemplateSelector/EngagementLetterTemplateSelector.utils";

/**
 * ExportClientsToExcelModal Component
 */
const ExportClientsToExcelModal: React.FC<{
  show: boolean;
  onHide: () => void;
  engagementlettertemplates: TemplateOption[];
  selectedclients: any[]
}> = ({ show, onHide, engagementlettertemplates, selectedclients  }) => {
  const [engagementLetterTemplateOptions, setEngagementLetterTemplateOptions] = useState<TemplateOption[]>([])
  const [engagementLetterTemplate, setEngagementLetterTemplate] = useState({'label':"", "value":""})
  const [clientMasterIds, setClientMasterIds] = useState<any[]>([])

  useEffect(() => { 
    setEngagementLetterTemplateOptions(engagementlettertemplates)
  }, [engagementlettertemplates])
  
  useEffect(() => {
    setClientMasterIds(selectedclients.map((item: any) => item.ClientMasterId))
  }, [selectedclients])

  
  return (
    <Modal
      show={show} 
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      centered
      className={"upload-spreadsheet-modal"}
      contentClassName={styles.modalContent}
      keyboard={false}
    >
      <Modal.Header closeButton style={{ padding: 0, margin: 0 }}>
      </Modal.Header>
      <Modal.Body style={{ padding: 0, margin: 0 }}>
        <Row style={{ padding: 20 }}>
          <label className="form-label move-left">Select engagement letter template</label>
          <Select
            options={engagementLetterTemplateOptions}
            value={engagementLetterTemplate}
            onChange={(event: any) => {
              setEngagementLetterTemplate(event);
            }}
            placeholder={"Select template"}
            aria-label="Default"
            className='custom-select '
            classNamePrefix="react-select"
          />
        </Row>
        <Row style={{ paddingLeft: 20, paddingRight: 20 }}>
          <TemplateDownload
            title={"Client Data (.xlsx)"}
            endpoint="/engagement-letter/bulk_export_excel/"
            params={{ 
              "TemplateId": engagementLetterTemplate.value, 
              "TemplateName": engagementLetterTemplate.label, 
              "ClientMasterIds": clientMasterIds 
            }}
            extension={"xlsx"}
            filename={engagementLetterTemplate.label + "_Bulk_Client_Data"}
            disabled={!engagementLetterTemplate?.value}
            showButton={true}
            onHide={onHide}
          />
        </Row>        
      </Modal.Body>
    </Modal>
  );
};

export default ExportClientsToExcelModal;
